import { useCallback } from 'react';

import { createStripeAccount } from 'api/stripe';
import { useEffect } from 'react';

const StripeRefreshOnboardingPage = () => {
  const fetchStripeOnboardingUrl = useCallback(async () => {
    const { url } = await createStripeAccount();
    window.location.replace(url);
  }, []);

  useEffect(() => {
    fetchStripeOnboardingUrl();
  }, [fetchStripeOnboardingUrl]);

  return <div></div>;
};

export default StripeRefreshOnboardingPage;
